export default __webpack_public_path__ + "static/media/shi.f691f9db.jpg";